import { Outlet, useParams } from "react-router-dom";
import PromotionsPage from "../../../modules/promotion/PromotionsPage";

const Tab6 = ({ routeBase = "/customer/promotions", mode }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PromotionsPage routeBase={routeBase} mode={mode} />;
};

export default Tab6;

